import {
  leadsSequencesDestroyMutation,
  leadsSequencesListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'

import { ActionsType } from './types'

export const DeleteCampaign = ({
  sequence,
  leadId,
  onCancel,
  ...props
}: ActionsType) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate, isPending } = useMutation({
    ...leadsSequencesDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsSequencesListQueryKey({ path: { lead_id: leadId } })
      ])

      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const handleDelete = () => {
    if (!sequence.sequence?.id) return

    mutate({
      path: { lead_id: String(leadId), sequence: Number(sequence.sequence.id) }
    })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={handleDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
